import axios from "../plugins/axios.plugin";

class RevenuePayoutService {
  baseServicePath = "/api/revenue/payout";

  getAllRevenuePayout(page) {
    return axios.get(`${this.baseServicePath}/index?page=${page}&properties=1`);
  }

  getAllRevenuePayoutsNoPagination(payload, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}&properties=1`,
      payload,
    );
  }

  showARevenuePayout(id) {
    return axios.get(`${this.baseServicePath}/show?id=${id}`);
  }

  searchRevenuePayout(payload) {
    return axios.post(`${this.baseServicePath}/search/index`, payload);
  }

  filterRevenuePayouts(payload, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}&properties=1`,
      payload,
    );
  }

  editRevenuePayout(payload) {
    return axios.post(`${this.baseServicePath}/update`, payload);
  }

  storeRevenuePayout(payload) {
    return axios.post(`${this.baseServicePath}/store`, payload);
  }

  approveRevenuePayout(payload) {
    return axios.post(`${this.baseServicePath}/approve`, payload);
  }

  rejectRevenuePayout(payload) {
    return axios.post(`${this.baseServicePath}/reject`, payload);
  }

  markRevenuePayoutPaid(payload) {
    return axios.post(`${this.baseServicePath}/mark/paid`, payload);
  }
}
export const revenuePayoutService = new RevenuePayoutService();
